(() => {

jQuery(document).ready(function() {
    var typedText = jQuery("#jail");
    var shouldBeText = "";
    var changeInto = "";
    var inProgress = false;
    function ChangeText(text) {
        shouldBeText = text;
        if (inProgress == false) {
            inProgress = true;
            changeInto = shouldBeText;
            RemoveText(function() {
                FillText(FillDone, typedText);
            });
        }
    }
    function FillText(callback, divClass) {
        divClass.removeData("typed");
        // jQuery('span.typed-cursor').hide();
        divClass.typed({
            typeSpeed: 200,
            backSpeed: 200,
            startDelay: 200,
            showCursor: false,
            strings: [
                changeInto
            ],
            callback: FillDone
        });
    }
    function FillDone() {
        inProgress = false;
        // jQuery('span.typed-cursor')
        // 	.show();
        if (shouldBeText != changeInto) ChangeText(shouldBeText);
    }
    function RemoveText(callback) {
        var word = typedText.html();
        var wordLength = word.length;
        var newWordLength = wordLength - 1;
        var newWord = word.slice(0, newWordLength);
        // jQuery('span.typed-cursor').hide();
        typedText.html(newWord);
        if (newWordLength === 0) callback();
        else setTimeout(function() {
            RemoveText(callback);
        }, 200);
    }
    if (jQuery("#homeheadone").length) window.setTimeout(inittyped, 2000);
    function inittyped() {
        typedText = jQuery("#jail");
        var lineheight = jQuery("#jailtypewrap").height();
        jQuery("#jailtypewrap").css("height", lineheight + "px");
        ChangeText("college.");
    }
    // homepage slick gallery
    var slider = jQuery(".homekidwrap");
    slider.on("init", function() {
        jQuery(".slick-active:nth-child(2n+1) h5").fadeIn("400");
        jQuery(".slick-active:nth-child(2n+1) p").fadeIn("400");
        jQuery(".slick-active:nth-child(2n+1) .childlink").fadeIn("400");
        jQuery(".slick-active:nth-child(2n+1) .storywrap").css("property", "value");
        jQuery(".slick-active:nth-child(2n+1) .storywrap").css("transform", "scale(1.1)");
    });
    slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
        var activecount = jQuery(".slick-active").length;
        var actindex = 1;
        if (activecount == 1) actindex = 0;
        var targetimg = nextSlide + actindex;
        jQuery(".slick-slide .deskcont h5").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-slide .deskcont p").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-slide .deskcont .childlink").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-slide .storywrap").each(function(index, el) {
            jQuery(this).css("transform", "scale(1)");
        });
        jQuery(".slick-active[data-slick-index=" + targetimg + "] .storywrap").css("transform", "scale(1.1)");
    });
    slider.on("afterChange", function(event, slick, currentSlide, nextSlide) {
        var activecount = jQuery(".slick-active").length;
        var actindex = 1;
        if (activecount == 1) actindex = 0;
        jQuery(".slick-slide .deskcont h5").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-slide .deskcont p").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-slide .deskcont .childlink").each(function(index, el) {
            jQuery(this).hide();
        });
        jQuery(".slick-active[data-slick-index=" + (currentSlide + actindex) + "] .deskcont h5").fadeIn("400");
        jQuery(".slick-active[data-slick-index=" + (currentSlide + actindex) + "] .deskcont p").fadeIn("400");
        jQuery(".slick-active[data-slick-index=" + (currentSlide + actindex) + "] .deskcont .childlink").fadeIn("400");
    });
    jQuery(".homekidwrap").slick({
        infinite: true,
        slidesToShow: 3,
        arrows: true,
        prevArrow: "<img class='a-left control-c prev slick-prev' src='/wp-content/themes/dfd-ronneby_child/img/arrow_left.png'>",
        nextArrow: "<img class='a-right control-c prev slick-next' src='/wp-content/themes/dfd-ronneby_child/img/arrow_right.png'>",
        dots: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // accordian
    var icons = {
        header: "ui-icon-minus",
        activeHeader: "ui-icon-plus"
    };
    jQuery(".accordian").each(function() {
        jQuery(this).accordion({
            icons: icons,
            collapsible: true,
            active: false,
            autoHeight: false,
            heightStyle: "content",
            active: false
        });
    });
    // selectize
    jQuery("#stateselect").selectize({
        allowEmptyOption: true,
        create: true
    });
    jQuery("#statepickerworkin").selectize({
        allowEmptyOption: true,
        create: true
    });
    jQuery("#field_45w2s2b").selectize({
        allowEmptyOption: true,
        create: true
    });
    jQuery("#field_xxda62b").selectize({
        allowEmptyOption: true,
        create: true
    });
    jQuery("#donationstateselect").selectize({
        allowEmptyOption: true,
        create: true
    });
    jQuery("#stateselect").change(function() {
        var state = jQuery(this).val();
        if (state == "Arkansas") window.location.href = "/become-a-scholar/arkansas/";
        if (state == "Arkansas-esp") window.location.href = "/become-a-scholar/arkansas-esp/";
        if (state == "Colorado") window.location.href = "/become-a-scholar/colorado/";
        if (state == "Colorado-esp") window.location.href = "/become-a-scholar/colorado-esp/";
        if (state == "Delaware-Maryland") window.location.href = "/become-a-scholar/delaware-maryland/";
        if (state == "Delaware-Maryland-esp") window.location.href = "/become-a-scholar/delaware-esp/";
        if (state == "Louisiana") window.location.href = "/become-a-scholar/louisiana/";
        if (state == "Louisiana-esp") window.location.href = "/become-a-scholar/louisiana-esp/";
        if (state == "Missouri") window.location.href = "/become-a-scholar/missouri/";
        if (state == "Missouri-esp") window.location.href = "/become-a-scholar/missouri-esp/";
        if (state == "Texas") window.location.href = "/become-a-scholar/texas/";
        if (state == "Texas-esp") window.location.href = "/become-a-scholar/texas-esp/";
        if (state == "Mississippi") window.location.href = "/become-a-scholar/mississippi/";
        if (state == "Mississippi-esp") window.location.href = "/become-a-scholar/mississippi-esp/";
        if (state == "Montana") window.location.href = "/become-a-scholar/montana/";
        if (state == "Montana-esp") window.location.href = "/become-a-scholar/montana-esp/";
        if (state == "Kansas") window.location.href = "/become-a-scholar/kansas/";
        if (state == "Kansas-esp") window.location.href = "/become-a-scholar/kansas-esp/";
        if (state == "Wyoming") window.location.href = "/become-a-scholar/wyoming/";
        if (state == "Wyoming-esp") window.location.href = "/become-a-scholar/wyoming-esp/";
        if (state == "New Mexico") window.location.href = "/become-a-scholar/new-mexico/";
        if (state == "New-Mexico-esp") window.location.href = "/become-a-scholar/new-mexico-esp/";
        if (state == "Utah") window.location.href = "/become-a-scholar/utah/";
        if (state == "Utah-esp") window.location.href = "/become-a-scholar/utah-esp/";
    });
    jQuery("#donationstateselect").change(function() {
        var state = jQuery(this).val();
        if (state == "Arkansas") window.location.href = "/blackbaud-donation-form-arkansas/";
        if (state == "ArkansasTaxCreditProgram") window.location.href = "/blackbaud-donation-form-arkansas-sgo/";
        if (state == "Colorado") window.location.href = "/blackbaud-donation-form-colorado/";
        if (state == "Delaware") window.location.href = "/blackbaud-donation-form-delaware/";
        if (state == "Kansas") window.location.href = "/blackbaud-donation-form-kansas/";
        if (state == "KansasTaxCreditProgram") window.location.href = "/blackbaud-donation-form-kansas-tax-credit/";
        if (state == "Louisiana") window.location.href = "/blackbaud-donation-form-louisiana/";
        if (state == "Mississippi") window.location.href = "/blackbaud-donation-form-mississippi/";
        if (state == "Montana") window.location.href = "/blackbaud-donation-form-montana/";
        if (state == "MontanaTaxCreditProgram") window.location.href = "/blackbaud-donation-form-mt-sso/";
        if (state == "Missouri") window.location.href = "/blackbaud-donation-form-missouri/";
        if (state == "New Mexico") window.location.href = "/blackbaud-donation-form-new-mexico/";
        if (state == "Texas") window.location.href = "/donate-tx/";
        if (state == "Utah") window.location.href = "/blackbaud-donation-form-utah/";
        if (state == "Wyoming") window.location.href = "/blackbaud-donation-form-wyoming/";
        if (state == "Greatest Need") window.location.href = "/blackbaud-donation-form-market-greatest-need/";
        if (state == "Honor Roll") window.location.href = "https://donate.acescholarships.org/Donate/honor_roll_campaign_mil";
    });
    jQuery("#donation2020stateselect").change(function() {
        var state = jQuery(this).val();
        if (state == "Arkansas") window.location.href = "/donate-luncheon-2020-ar/";
        if (state == "Colorado") window.location.href = "/donate-luncheon-2020-co/";
        if (state == "Kansas") window.location.href = "/donate-luncheon-2020-ks/";
        if (state == "Louisiana") window.location.href = "/donate-luncheon-2020-la/";
        if (state == "Montana") window.location.href = "/donate-luncheon-2020-mt/";
        if (state == "Missouri") window.location.href = "/donate-luncheon-2020-mo/";
        if (state == "Texas Austin") window.location.href = "/donate-luncheon-2020-atx/";
        if (state == "Texas Dallas Fort Worth") window.location.href = "/donate-luncheon-2020-dfw/";
        if (state == "Texas Houston") window.location.href = "/donate-luncheon-2020-hou/";
        if (state == "Texas San Antonio") window.location.href = "/donate-luncheon-2020-satx/";
        if (state == "Wyoming") window.location.href = "/donate-luncheon-2020-wy/";
        if (state == "Market of Greatest Need") window.location.href = "/donate-luncheon-2020-mgn/";
        if (state == "Greatest Need") window.location.href = "/donate-luncheon-2020-mgn/";
        if (state == "General Operations") window.location.href = "/donate-luncheon-2020-ops/";
    });
    jQuery("#statepickerworkin").change(function() {
        var state = jQuery(this).val();
        if (state == "Arkansas") window.location.href = "/states-we-work-in/states-we-work-in-arkansas/";
        if (state == "Colorado") window.location.href = "/states-we-work-in/states-we-work-in-colorado/";
        if (state == "Delaware") window.location.href = "/states-we-work-in/states-we-work-in-delaware-maryland/";
        if (state == "Louisiana") window.location.href = "/states-we-work-in/states-we-work-in-louisiana/";
        if (state == "Texas") window.location.href = "/states-we-work-in/states-we-work-in-texas/";
        if (state == "Mississippi") window.location.href = "/states-we-work-in/states-we-work-in-mississippi/";
        if (state == "Missouri") window.location.href = "/states-we-work-in/states-we-work-in-missouri/";
        if (state == "Montana") window.location.href = "/states-we-work-in/states-we-work-in-montana/";
        if (state == "Kansas") window.location.href = "/states-we-work-in/states-we-work-in-kansas/";
        if (state == "Wyoming") window.location.href = "/states-we-work-in/states-we-work-in-wyoming/";
        if (state == "New Mexico") window.location.href = "/states-we-work-in/states-we-work-in-new-mexico/";
        if (state == "Utah") window.location.href = "/states-we-work-in/states-we-work-in-utah/";
    });
    // accordian elements
    jQuery(".desclink").click(function(event) {
        var discid = this.id;
        discid = discid.substring(3);
        jQuery("#desc_" + discid).slideToggle("400");
        return false;
    });
    // packery / isotope
    jQuery(".grid").isotope({
        layoutMode: "packery",
        itemSelector: ".grid-item",
        packery: {
            gutter: 0
        }
    });
    if (jQuery("#aceluncheon2022").length) {
        var resources = jQuery(".newtarget .wpb_wrapper");
        jQuery.fancybox.open({
            src: ".newtarget",
            type: "inline",
            opts: {
                afterShow: function(instance, current) {
                    console.info("done!");
                }
            }
        });
    }
    if (jQuery(".alumniaccordian").length) {
        console.log("here");
        jQuery(".alumlink").click(function(event) {
            var alumid = this.id;
            alumid = alumid.substring(4);
            jQuery.fancybox.open({
                src: "#alumcnt" + alumid,
                type: "inline",
                opts: {
                    afterShow: function(instance, current) {
                        console.info("done!");
                    }
                }
            });
            return false;
        });
    }
    if (jQuery(".visionspeakers").length) jQuery(".biolink").click(function(event) {
        var bioid = this.id;
        bioid = bioid.substring(3);
        jQuery.fancybox.open({
            src: "#biocnt" + bioid,
            type: "inline",
            opts: {
                afterShow: function(instance, current) {
                    console.info("done!");
                }
            }
        });
        return false;
    });
});



})();
//# sourceMappingURL=parcel.js.map
